import { get, post } from "@/utils/http";

let baseURL = "/menu";
/**
 *根据权限获取菜单列表
 */
const getMenuList = data => get(`${baseURL}/getMenuList`, data);
/**
 *获取所有菜单列表
 */
const getAllMenu = data => get(`${baseURL}/getAllMenu`, data);
/**
 *菜单和角色绑定
 */
const setMenuBindRole = data => get(`${baseURL}/setMenuBindRole`, data);

// API
export default {
  getMenuList,
  getAllMenu,
  setMenuBindRole
};
